export const Try2Combo: { id: string; title: string; sm_title: string }[] = [
  {
    id: '1',
    title: 'item #1',
    sm_title: 'item 1',
  },
  {
    id: '2',
    title: 'item #2',
    sm_title: 'item 2',
  },
];
